import React from 'react'
import { ThemeProvider } from './context/ThemeContext'
import HiFiVisualizer from './components/HiFiVisualizer'
import './App.css'

const App: React.FC = () => {
  return (
    <div className="app-container">
      <ThemeProvider>
        <div className="hifi-wrapper">
          {/* <h1 className="hifi-title">CoolWaves Hi-Fi</h1> */}
          <HiFiVisualizer />
        </div>
      </ThemeProvider>
    </div>
  )
}

export default App
